import "./StartAProject.module.css";
import Header from "@/reusable_sections/Header";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function StartAProjectPage() {
  return <div>
      <Header />
      <ContactUs />
      <Footer />
    </div>;
}